// /signup-confirmation, before Continue (server core/auth-takeover-paths
// review r4 N2). Continue signs the browser in as the account the token
// confirms. The page therefore names that account, read from the SERVER
// (sdk.previewRegisterConfirmation — never the `email` URL param, which
// anyone can write), and says so when the browser holds a session for
// another account, so a victim sent an attacker's own link sees whose
// account it is before pressing Continue. Read only: no confirm, no session
// write. Runs once per page (the ConfirmContinue step's onRender).
export const previewConfirmation = async function previewConfirmation() {
  const s = this.state
  if (s.previewRequested) return
  s.update({ previewRequested: true })

  const sdk = this.sdk
  let signedInEmail = ''
  if (sdk?._tokenManager?.getAccessToken?.() && typeof sdk.getMe === 'function') {
    try {
      const me = await sdk.getMe()
      const u = (me && (me.data?.user || me.user)) || me || {}
      signedInEmail = String(u.email || '')
    } catch (_) {
      signedInEmail = ''
    }
  }

  const token = new URLSearchParams(window.location.search).get('token')
  if (!token) {
    s.update({ awaitingContinue: false, success: false, error: this.call('polyglot', 'auth.confirm.invalidLink') })
    return
  }

  // An SDK without the preview (older published build): the address stays
  // unnamed and any signed-in account is reported as possibly replaced.
  if (typeof sdk?.previewRegisterConfirmation !== 'function') {
    s.update({ previewReady: true, targetEmail: '', otherAccountEmail: signedInEmail })
    return
  }

  try {
    const out = await sdk.previewRegisterConfirmation(token)
    const targetEmail = String(out?.email || '')
    const other =
      signedInEmail && signedInEmail.toLowerCase() !== targetEmail.toLowerCase() ? signedInEmail : ''
    s.update({ previewReady: true, targetEmail, otherAccountEmail: other })
  } catch (error) {
    s.update({ awaitingContinue: false, success: false, error: error?.message || 'error' })
  }
}
